import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-6 lg:px-12 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=fashion%20lifestyle%20flatlay%20with%20leather%20crossbody%20bag%2C%20minimalist%20watch%2C%20gold%20jewelry%20on%20warm%20terracotta%20linen%2C%20soft%20sunlight%20highlights%2C%20earthy%20sand%20tones%2C%20European%20editorial%20boutique%20style%2C%20clean%20sophisticated%20composition&width=1920&height=800&seq=kakobuy-cta-v8&orientation=landscape"
          alt="Kakobuy - akcesoria modowe na ciepłym tle"
          title="Kakobuy Spreadsheet - akcesoria i dodatki"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/30"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
        {/* Left: Text */}
        <div className="max-w-xl">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
            Gotowy, aby zacząć <span className="text-primary-300">oszczędzać?</span>
          </h2>
          <p className="text-base md:text-lg text-background-50/80 leading-relaxed">
            Przejdź do pełnego arkusza Kakobuy Spreadsheet i odkryj setki sprawdzonych produktów w najlepszych cenach.
          </p>
        </div>

        {/* Right: CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold bg-background-50 text-foreground-950 hover:bg-background-100 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>

          <Link
            to="/kakobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold bg-background-50/15 backdrop-blur-sm text-background-50 hover:bg-background-50/25 border border-background-50/30 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Przeczytaj poradnik
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-book-open-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}